module.exports = __webpack_public_path__ + "static/media/menu-dinein.870eae43.svg";